import React from 'react';
import { createRoot } from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import './index.css';
import './styles/quill.css';

import { QueryClientProvider } from '@tanstack/react-query';

import { CssBaseline } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';

import App from './Application';
import { queryClient } from './lib/react-query';

import './assets/i18n';

const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
  <React.Fragment>
    <CssBaseline />
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </BrowserRouter>
  </React.Fragment>
);

// 接入 web-vitals 采集（03-1.5）：开发期输出 CLS/FID/FCP/LCP/TTFB 基线，
// 生产构建经 terser drop_console 移除，可替换为实际上报端点
reportWebVitals(console.info);
